import { RecordStore } from '@deqo/foundation';
import { AccountLiteDataWithExternality, CredentialsData, ExternalSystemConnectionData, ProfileData } from '../api/endpoints/me';
import { Colors } from './../ui';

const profileTemplate = {
    id: '',
    legacyId: null as string | undefined,
    type: 1,
    name: '',
    shortName: '',
    initials: '',
    email: '',
    emailSubscribed: false,
    emailVerified: false,
    photo: '',
    color: Colors.primary,
    handwriting: 'Kalam',
    integrations: {
        calendar: true,
    },
    external: false,
    accounts: [] as AccountLiteDataWithExternality[],
    credentials: [] as CredentialsData[],
    connections: [] as ExternalSystemConnectionData[],
    // flags: {} as Record<string, boolean>,
    createdAt: new Date(),
};

export class ProfileModel extends RecordStore(profileTemplate) {

    public get isAnonymous() {
        return this.id === 'US000000ANON';
    }

    public static async load(provider: () => Promise<ProfileData>) {
        const initial = await provider();
        const model = new ProfileModel();
        model.setState(initial);
        return [
            model,
            async () => {
                const latest = await provider();
                model.updateState(latest);
            }
        ] as const;
    }
}
